import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";
import BulkUploadSummary from "./BulkUploadSummery";
import AddBPUserComponent from "./component";

const AddBPUserContainer = ({ getDataFromAPI }) => {
  const { id } = useParams();

  const [singleUser, setSingleUser] = useState({
    orgId: "",
    department: "",
    userName: "",
    businessId: "",
  });

  const [openBulkModal, setOpenBulkModal] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [parsedBulkUsers, setParsedBulkUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [summaryData, setSummaryData] = useState(null);

  const downloadCSVTemplate = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      "Organization ID,Department Name,Employee Name,Business Email\n" +
      "EMP001,HR,John Doe,john@example.com\n" +
      "EMP002,IT,Jane Smith,jane@example.com";
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "user_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

const handleCreateNewUser = () => {
  const userPayload = {
    index: 1,
    employeeId: singleUser.orgId,
    businessName: singleUser.department,
    employeeName: singleUser.userName,
    employeeEmail: singleUser.businessId,
  };

  const payload = {
    userInfoList: [userPayload],
  };

  setIsLoading(true);

  getDataFromAPI(
    `/partner/api/v1/business-profile/${id}`,
    "POST",
    payload,
    (res) => {
      const data = res || {};

      setSummaryData({
        usersAdded: data.usersAdded || 0,
        successes: data.successes || [],
        failures: data.failures || [],
        totalAttempted: 1,
        source: "single",
      });

      setSingleUser({ orgId: "", department: "", userName: "", businessId: "" });
      setIsLoading(false);

      if (data.usersAdded > 0) {
        toastr.success("Success", "User created successfully");
      } else {
        toastr.error("Error", "User creation failed");
      }
    },
    (err) => {
      setSummaryData({
        usersAdded: 0,
        successes: [],
        failures: [{
          ...userPayload,
          reason: err?.message || "User creation failed",
        }],
        totalAttempted: 1,
        source: "single",
      });

      setIsLoading(false);
      toastr.error("Error", "Failed to create user");
    }
  );
};



  const handleBulkFileUpload = (file) => {
    setBulkFile(file);
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const csvText = e.target.result;
        const rows = csvText.split("\n").filter((line) => line.trim() !== "");
        if (rows.length < 2) {
          toastr.error("Error", "CSV file is empty or has no data rows");
          return;
        }

        const parsed = rows.slice(1).map((row, index) => {
          const values = row.split(",").map((v) => v.trim());
          return {
            index: index + 1,
            employeeId: values[0] || "",
            businessName: values[1] || "",
            employeeName: values[2] || "",
            employeeEmail: values[3] || "",
          };
        }).filter(user => user.employeeId && user.employeeName && user.employeeEmail);

        setParsedBulkUsers(parsed);
        toastr.success("Success", `Found ${parsed.length} valid users`);
      } catch {
        toastr.error("Error", "Failed to parse CSV file");
      }
    };

    reader.onerror = () => toastr.error("Error", "Failed to read file");
    reader.readAsText(file);
  };

  const handleBulkAddUser = () => {
    if (parsedBulkUsers.length === 0) {
      toastr.error("Error", "No valid users to upload");
      return;
    }

    setIsLoading(true);

    getDataFromAPI(
      `/partner/api/v1/business-profile/${id}`,
      "POST",
      { userInfoList: parsedBulkUsers },
      (res) => {
        const data = res || {};
        setSummaryData({
          usersAdded: data.usersAdded || 0,
          successes: data.successes || [],
          failures: data.failures || [],
          totalAttempted: parsedBulkUsers.length,
        });

        setParsedBulkUsers([]);
        setBulkFile(null);
        setOpenBulkModal(false);
        setIsLoading(false);
        toastr.success("Success", "Bulk upload complete");
      },
      (err) => {
        const failures = parsedBulkUsers.map((u) => ({
          ...u,
          reason: err?.message || "Server error",
        }));

        setSummaryData({
          usersAdded: 0,
          successes: [],
          failures,
          totalAttempted: parsedBulkUsers.length,
        });

        setParsedBulkUsers([]);
        setIsLoading(false);
        toastr.error("Error", "Bulk upload failed");
      }
    );
  };

  return summaryData ? (
    <BulkUploadSummary data={summaryData} />
  ) : (
    <AddBPUserComponent
      singleUser={singleUser}
      setSingleUser={setSingleUser}
      handleCreateNewUser={handleCreateNewUser}
      openBulkModal={openBulkModal}
      setOpenBulkModal={setOpenBulkModal}
      handleBulkFileUpload={handleBulkFileUpload}
      parsedBulkUsers={parsedBulkUsers}
      handleBulkAddUser={handleBulkAddUser}
      downloadCSVTemplate={downloadCSVTemplate}
      setParsedBulkUsers={setParsedBulkUsers}
      bulkFile={bulkFile}
      setBulkFile={setBulkFile}
      isLoading={isLoading}
    />
  );
};

export default connect(null, { getDataFromAPI })(AddBPUserContainer);
